
import React, { useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Database } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

// SharePoint node component for the flow editor
export const SharePointNode = ({ data, isConnectable }: any) => {
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(isMobile);
  
  return (
    <div className="bg-white border rounded-md shadow-sm p-2 w-[200px]">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-2 h-2 rounded-full bg-blue-500 border-2 border-white"
      />
      
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Database className="h-4 w-4 text-blue-500" />
          <span className="font-medium text-sm truncate max-w-[130px]">{data.label}</span>
        </div>
        {isMobile && (
          <button 
            onClick={() => setCollapsed(!collapsed)}
            className="text-gray-500 hover:text-gray-700"
          >
            {collapsed ? '+' : '-'}
          </button>
        )}
      </div>
      
      {!collapsed && (
        <div className="mt-2 text-xs space-y-1 text-gray-600">
          <div className="flex justify-between">
            <span>List:</span> 
            <span className="font-medium">{data.listName || 'Not set'}</span>
          </div>
          <div className="flex justify-between">
            <span>Operation:</span> 
            <span className="font-medium">{data.operation || 'Read'}</span>
          </div>
          {data.filter && (
            <div className="flex justify-between">
              <span>Filter:</span> 
              <span className="font-medium truncate max-w-[120px]">{data.filter}</span>
            </div>
          )}
        </div>
      )}
      
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="w-2 h-2 rounded-full bg-blue-500 border-2 border-white"
      />
    </div>
  );
};
